import { Component } from '@angular/core';
import { UpcomingTripEmptyComponent } from '../upcoming-trip-empty/upcoming-trip-empty.component';

@Component({
    selector: 'app-my-trips',
    templateUrl: './my-trips.component.html',
    styleUrls: ['./my-trips.component.scss'],
    imports: [UpcomingTripEmptyComponent]
})
export class MyTripsComponent {

}
